import React, { ReactNode } from 'react';
import classList from 'utils/classlist';

import Title from 'components/Title';

import './style.scss';

export interface IAboutPageProps {
    title: string;
    header?: ReactNode;

    paragraph?: string[];
    // 是否不需要行之间的margin-top属性
    noMarginTop?: boolean;
}

const AboutPage: React.FC<IAboutPageProps> = ({ title, header, paragraph, noMarginTop }) => {
    return (
        <div className="brand-about-root">
            <Title title={title} />
            <div className="banner">
                <div className="banner-info site-main">
                    <div className="banner-title a-flyTopIn">
                        {header && <h2 className="about-header">{header}</h2>}
                        {paragraph?.map((item, index) => (
                            <h3 className={classList({ text: index, 'mt-0': noMarginTop })} key={index}>
                                {item}
                            </h3>
                        ))}
                    </div>
                </div>
            </div>
            <section className="contact section">
                <div className="site-main aninode">
                    <div data-animation="a-flyRightIn">
                        <h2 className="contact-title">Contact Us</h2>
                        <p>Address: 437 MADISON AVE , 27TH FLOOR , NEW YORK, NY 10022 USA</p>
                        <p>
                            Email:{' '}
                            <a className="email" href="mailto:support@tradeup.com">
                                support@tradeup.com
                            </a>
                        </p>
                        <p>
                            Fax: <a href="tel:(646)-514-6688">(646)-514-6688</a>
                        </p>
                        <p>Office Hours: Monday 9am (EST) to Friday 5pm (EST)</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutPage;
